import React, { useCallback, useState } from 'react';

import GeneralHeader from 'components/common/GeneralHeader';
import useNotice from 'hooks/useNotice';
import { POST } from 'utils';

import One from 'components/form/register/One';
import { removeEmpty } from 'utils/common_function';

import Four from 'components/form/register/Four';
import Three from 'components/form/register/Three';
import Two from 'components/form/register/Two';
import { useNavigate } from 'react-router-dom';
import { api } from 'utils/apiRoutes';
import { Loading } from 'components';

const defaultValue = {
  active_modules: [
    'hr_portal',
    'absence_management',
    'expense_report',
    'time_activities',
  ],
};

const AddUser = () => {
  const { error } = useNotice();
  const [loading, setLoading] = React.useState<boolean>(false);
  /*  const [state, setState] = useState({
    onOpen: false,
    exitingUser: false,
    choiceExitingUser: null,
    user: [] as personalData[],
    workShiftData: [{ label: '', value: '' }],
  }); */
  const [formData, setFormData] = useState(defaultValue);
  const [current, setCurrent] = useState(0);
  const [fieldError, setFieldError] = useState<object[] | null>(null);

  const navigate = useNavigate();

  const steps = [1, 2, 3, 4];

  const back = useCallback((data: object) => {
    setFormData((formData) => ({ ...formData, ...data }));
    setCurrent((prev) => prev - 1);
  }, []);

  const Submit = useCallback((data: object) => {
    setFormData((formData) => ({ ...formData, ...data }));
    setCurrent((p) => p + 1);
  }, []);

  const createUser = async (data: object) => {
    const formValue = removeEmpty({ ...formData, ...data });
    if (loading) return;
    setLoading(true);
    try {
      return await POST(api.register, formValue).then((res) => {
        setLoading(false);
        if (res.status === 201) {
          navigate('/on_boarding', {
            state: { boarding_id: res?.data?.on_boarding_id },
          });
        }
      });
    } catch (err) {
      setLoading(false);
      if (err?.response?.status === 500) {
        error('Something went wrong');

        return;
      }
      setFieldError(err?.response?.data);
      const outputObject = Object.fromEntries(
        Object.entries(err?.response?.data).slice(0, 5),
      );
      const divElements = Object.entries(outputObject).map(([key, value]) => {
        if (typeof value[0] === 'object') return '';
        return (
          <div
            style={{ color: '#E02C2C', fontWeight: 400, fontSize: 14 }}
            key={key}
          >
            {value[0] ? value[0] : ' is mandatory'}
          </div>
        );
      });
      error('Missing or incorrect information', divElements);
    }
  };

  /*   useEffect(() => {
    if (choiceExitingUser)
      getUserById(`${choiceExitingUser}/`).then((res) => {
        const user = res?.data as personalData[];
        setState((pre) => ({
          ...pre,
          user,
        }));
      });
  }, [choiceExitingUser]);

  useEffect(() => {
    getWorkshiftList().then((res) => {
      setState((pre) => ({
        ...pre,
        workShiftData: res?.results?.map((item) => {
          return {
            label: item.name,
            value: item.id,
          };
        }),
      }));
    });
  }, []); */

  return (
    <div>
      <GeneralHeader
        pageTitle="Add a collaborator"
        icon="/icons/add_collaborator.svg"
        child={
          <div>
            <div
              style={{
                width: '100%',
                marginTop: '100px',
              }}
            >
              <div
                style={{
                  width: '60%',
                  position: 'relative',
                  alignItems: 'center',
                }}
                className="is-flex  is-flex-wrap-wrap"
              >
                {steps.map((item, idx) => (
                  <>
                    <div
                      key={idx}
                      className={
                        'is-flex is-flex-direction-column is-align-items-center'
                      }
                      style={{ gap: 6 }}
                    >
                      <div
                        style={{
                          opacity: current === idx ? '1' : '0',
                          transition: 'all',
                          transitionDuration: '300ms',
                          transitionTimingFunction: 'ease-in-out',
                          position: 'absolute',
                          top: '-30px',
                        }}
                      >
                        <img
                          alt={'icon'}
                          src={'/icons/arrow_select.svg'}
                          width={24}
                        />
                      </div>

                      <div
                        className={`has-text-centered step`}
                        style={{
                          background: current >= idx && '#407fdd',
                          color: current >= idx && 'white',
                          transition: 'all',
                          transitionDuration: '300ms',
                          transitionTimingFunction: 'ease-in-out',
                        }}
                      >
                        <p>{item}</p>
                      </div>
                    </div>
                    <div
                      style={{
                        position: 'relative',
                        width: '25%',
                      }}
                    >
                      {idx < steps?.length - 1 && (
                        <>
                          <div
                            style={{
                              height: 3,
                              position: 'absolute',
                              background: '#D4EAFF',
                              width: '100%',
                              transition: 'width 300ms ease-in-out',
                            }}
                          />
                          <div
                            style={{
                              height: 3,
                              position: 'absolute',
                              background: '#407fdd',
                              width: current > idx ? '100%' : '0',
                              transition: 'width 300ms ease-in-out',
                            }}
                          />
                        </>
                      )}
                    </div>
                  </>
                ))}
              </div>
            </div>
            <div className="mt-6">
              {
                {
                  0: <One form_data={formData} onSubmit={Submit} />,
                  1: (
                    <Two form_data={formData} onSubmit={Submit} onBack={back} />
                  ),
                  2: (
                    <Three
                      form_data={formData}
                      onSubmit={Submit}
                      onBack={back}
                    />
                  ),
                  3: (
                    <Four
                      form_data={formData}
                      onSubmit={createUser}
                      onBack={back}
                      fieldError={fieldError}
                    />
                  ),
                }[current]
              }
            </div>
          </div>
        }
      />
    </div>
  );
};

export default AddUser;
